<template>
  <fieldset>
    <div class="form-wrap">
      <div>
        <label for="accommodation-name">Accommodation Name</label>
        <input type="text" id="accommodation-name" v-model="$parent.accommodation.accommodation_name">
      </div>

      <div>
        <label for="phone">Phone Number</label>
        <input id="phone" type="text" v-model="$parent.accommodation.phone_number">
      </div>

      <div>
        <label for="address">Address</label>
        <input id="address" type="text" v-model="$parent.accommodation.address">
      </div>

      <div>
        <label for="accommodation-resort">Resort</label>
        <v-select
          v-model="$parent.accommodation.resort_id"
          :options="resorts"
          label="resort_name"
          id="accommodation-resort"
          index="id"
        />
      </div>

      <div>
        <label for="accommodation-supplier">Supplier</label>
          <v-select
            v-model="$parent.accommodation.supplier_id"
            :options="suppliers"
            label="supplier_name"
            id="accommodation-supplier"
            index="id"
          />
      </div>
    </div>
    <hr>
    <div class="row p-3">
      <div class="col-md-6">
          <div class="form-group">
            <label for="">Star Rating</label>
            <select class="form-control" style="height: auto;" v-model="$parent.accommodation.star_rating">
              <option value="">Select</option>
              <option value="1">1 Star</option>
              <option value="2">2 Star</option>
              <option value="3">3 Star</option>
              <option value="4">4 Star</option>
              <option value="5">5 Star</option>
            </select>
          </div>
      </div>
      <div class="col-md-6">
          <div class="row">
              <div class="col-md-12">
                  <div class="form-group">
                    <label for="">Short Description</label>
                    <textarea class="form-control" placeholder="Short Description" style="resize: none; height: 150px;" v-model="$parent.accommodation.short_description"></textarea>
                  </div>
              </div>
          </div>
      </div>
  </div>
  </fieldset>
</template>

<script>
export default {
  name: 'AccommodationFields',
  data () {
    return {
      loading: false,
      suppliers: [],
      resorts: [],
    }
  },
  mounted() {
    this.getSuppliersAndResorts();
  },
  methods: {
    getSuppliersAndResorts() {
      this.$store.dispatch('setLoadStatus')
      fetch( this.$api + 'accommodation/supplier-and-resorts', {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.suppliers = response.data.suppliers;
        this.resorts = response.data.resorts;
      })
    },
  }
}
</script>
